export const ExternalIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.3335 4.3398C3.15668 4.3398 2.98712 4.41004 2.86209 4.53507C2.73707 4.66009 2.66683 4.82966 2.66683 5.00647V12.3398C2.66683 12.5166 2.73707 12.6862 2.86209 12.8112C2.98712 12.9362 3.15669 13.0065 3.3335 13.0065H10.6668C10.8436 13.0065 11.0132 12.9362 11.1382 12.8112C11.2633 12.6862 11.3335 12.5166 11.3335 12.3398V8.3398C11.3335 7.97161 11.632 7.67314 12.0002 7.67314C12.3684 7.67314 12.6668 7.97161 12.6668 8.3398V12.3398C12.6668 12.8702 12.4561 13.3789 12.081 13.754C11.706 14.1291 11.1973 14.3398 10.6668 14.3398H3.3335C2.80306 14.3398 2.29436 14.1291 1.91928 13.754C1.54421 13.3789 1.3335 12.8702 1.3335 12.3398V5.00647C1.3335 4.47604 1.54421 3.96733 1.91928 3.59226C2.29436 3.21718 2.80306 3.00647 3.3335 3.00647H7.3335C7.70169 3.00647 8.00016 3.30495 8.00016 3.67314C8.00016 4.04133 7.70169 4.3398 7.3335 4.3398H3.3335Z"
        fill="#434647"
      />
      <path
        d="M10.0002 1.00647C9.63197 1.00647 9.3335 1.30495 9.3335 1.67314C9.3335 2.04133 9.63197 2.3398 10.0002 2.3398H12.3907L6.19543 8.53506C5.93508 8.79541 5.93508 9.21752 6.19543 9.47787C6.45577 9.73822 6.87788 9.73822 7.13823 9.47787L13.3335 3.28261V5.67314C13.3335 6.04133 13.632 6.3398 14.0002 6.3398C14.3684 6.3398 14.6668 6.04133 14.6668 5.67314V1.67314C14.6668 1.30495 14.3684 1.00647 14.0002 1.00647H10.0002Z"
        fill="#434647"
      />
    </svg>
  );
};
